import { useState } from 'react'

import { Box, Button, Card, Divider, Text } from '@factorialco/deprecated-design-system'
import { EmployeesCollectionHeaderDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { DATEV_LAUDS_INTEGRATION_ID } from 'modules/marketplace/lib/integrationIds'

import DatevImporterCallout from './DatevImporterCallout'
import NotInvitedModal from './NotInvitedModal'
import PendingModal from './PendingModal'

const Header = () => {
  const { company } = useCurrentSession()
  const [isPendingModalHidden, setIsPendingModalHidden] = useState(true)
  const [isNotInvitedModalHidden, setIsNotInvitedModalHidden] = useState(true)
  const { data, loading, refetch } = useQuery(EmployeesCollectionHeaderDocument)
  const employeesPending = data?.employees?.employeesPending?.edges.map((edge) => edge.node) ?? []
  const employeesNotInvited =
    data?.employees?.employeesNotInvited?.edges.map((edge) => edge.node) ?? []
  const { data: companyInstallationsData } = useGetMarketplaceCompanyInstallations(
    {
      companyIds: [company.id],
    },
    false
  )
  const hasDatevIntegration = companyInstallationsData?.some(
    (installation) => installation.integrationDatoId === DATEV_LAUDS_INTEGRATION_ID
  )
  const handlePendingModalClicked = () => {
    track(trackingEvents.employee.employeesSendInviteStart)
    setIsPendingModalHidden(!isPendingModalHidden)
  }

  const handleNotInvitedModalClicked = () => {
    track(trackingEvents.employee.employeesSendInviteStart)
    setIsNotInvitedModalHidden(!isNotInvitedModalHidden)
  }

  if (loading) {
    return null
  }

  return (
    <>
      {hasDatevIntegration && (
        <Box gap="s8" paddingBottom="s16">
          <DatevImporterCallout />
        </Box>
      )}
      <Box width="s400" flexGrow>
        <Card>
          <Card.Content>
            <Box flexDirection="column" width="full" gap="s16">
              <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
                <Text size="300" whiteSpace="nowrap">
                  {employeesPending.length} {i18n.t('employees.adming_header.pending_to_accept')}
                </Text>
                <Button
                  type="secondary"
                  onClick={() => handlePendingModalClicked()}
                  disabled={!employeesPending.length}
                  iconName="settings"
                />
              </Box>
              <Divider />
              <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
                <Text size="300" whiteSpace="nowrap">
                  {employeesNotInvited.length} {i18n.t('employees.adming_header.not_invited')}
                </Text>
                <Button
                  type="secondary"
                  onClick={() => handleNotInvitedModalClicked()}
                  disabled={!employeesNotInvited.length}
                  iconName="settings"
                />
              </Box>
            </Box>
          </Card.Content>
        </Card>
      </Box>
      <PendingModal
        isHidden={isPendingModalHidden}
        employees={employeesPending}
        onClose={() => {
          setIsPendingModalHidden(true)
          refetch()
        }}
      />
      <NotInvitedModal
        isHidden={isNotInvitedModalHidden}
        employees={employeesNotInvited}
        onClose={() => {
          setIsNotInvitedModalHidden(true)
          refetch()
        }}
      />
    </>
  )
}

export default Header
